import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  section: {
    marginBottom: 20
  },
  sectionTitle: {
    marginBottom: 12
  },
  list: {
    marginBottom: 12
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    padding: 12,
    borderRadius: 8,
    backgroundColor: palette.shades[250],
    marginBottom: 8,
    '&:last-child': {
      marginBottom: 0
    }
  },
  itemIconTile: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 44,
    height: 44,
    borderRadius: 8,
    backgroundColor: palette.shades[100]
  },
  itemIconBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: palette.shades[700],
    color: palette.shades[100],
    '& .MuiSvgIcon-root': {
      width: 16,
      height: 16
    },
    '& .MuiSvgIcon-root path': {
      fill: 'currentColor'
    }
  },
  itemSkeleton: {
    borderRadius: 8,
    marginBottom: 8,
    '&:last-child': {
      marginBottom: 0
    }
  },
  itemMain: {
    flex: 1,
    minWidth: 0
  },
  itemTitle: {
    '&&': {
      fontFamily: palette.fontFamilies.poppins,
      fontWeight: 600,
      fontSize: 13,
      lineHeight: 1,
      letterSpacing: 0
    }
  },
  itemLine: {
    '&&': {
      display: 'block',
      marginTop: 5,
      fontFamily: palette.fontFamilies.source,
      fontWeight: 400,
      fontSize: 13,
      lineHeight: 1,
      letterSpacing: 0,
      color: palette.shades[700]
    }
  },
  itemActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexShrink: 0,
    '& .MuiIconButton-root': {
      width: 36,
      height: 36,
      borderRadius: 8,
      backgroundColor: palette.shades[100],
      '& .MuiSvgIcon-root': {
        width: 18,
        height: 18
      }
    }
  },
  scheduleButton: {
    '&&.Mui-disabled': {
      backgroundColor: palette.shades[200],
      border: "1px solid ".concat(palette.shades[300]),
      color: palette.shades[500],
      '& .MuiSvgIcon-root path': {
        fill: palette.shades[500]
      }
    }
  },
  menuPaper: {
    width: 300,
    marginTop: 8,
    borderRadius: 0,
    boxShadow: palette.shadows.hard
  },
  menuItem: {
    gap: 16,
    padding: '14px 14px'
  },
  menuIcon: {
    display: 'flex',
    flexShrink: 0,
    color: palette.shades[700],
    '& .MuiSvgIcon-root': {
      width: 22,
      height: 22
    },
    '& .MuiSvgIcon-root path': {
      fill: 'currentColor'
    }
  },
  menuLabel: {
    '&&': {
      fontFamily: palette.fontFamilies.poppins,
      fontWeight: 600,
      fontSize: 14,
      lineHeight: '18px'
    }
  },
  menuItemDisabled: {
    pointerEvents: 'none',
    '& $menuLabel': {
      color: palette.shades[500]
    },
    '& $menuCaption': {
      color: palette.shades[500]
    },
    '& $menuIcon': {
      color: palette.shades[400]
    }
  },
  menuCaption: {
    '&&': {
      display: 'block',
      color: palette.shades[700],
      fontSize: 12,
      lineHeight: '18px'
    }
  }
});
export default useStyles;